import { getRetailer } from "@faire/marketplace-lib/serialized-data/getRetailer";
import React, { createContext, useContext, useMemo } from "react";
import { createStore, StoreApi, useStore } from "zustand";

import { useRetailerCoreWithSelector } from "./RetailerCoreProvider";

interface ExpandingOffer {
  isPreQualifiedForExpandingOffer: boolean;
  isPreApprovedForExpandingOffer: boolean;
}

const ExpandingOfferContext = createContext<
  StoreApi<ExpandingOffer> | undefined
>(undefined);

export const ExpandingOfferProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const initialRetailer = getRetailer();
  const retailer = useRetailerCoreWithSelector((state) => state.retailer);

  const store = useMemo(
    () =>
      createStore<ExpandingOffer>(() => ({
        isPreQualifiedForExpandingOffer:
          retailer?.is_pre_qualified_for_expanding_offer ??
          initialRetailer?.is_pre_qualified_for_expanding_offer ??
          false,
        isPreApprovedForExpandingOffer:
          retailer?.is_pre_approved_for_expanding_offer ??
          initialRetailer?.is_pre_approved_for_expanding_offer ??
          false,
      })),
    [
      retailer?.is_pre_qualified_for_expanding_offer,
      initialRetailer?.is_pre_qualified_for_expanding_offer,
      retailer?.is_pre_approved_for_expanding_offer,
      initialRetailer?.is_pre_approved_for_expanding_offer,
    ]
  );

  return (
    <ExpandingOfferContext.Provider value={store}>
      {children}
    </ExpandingOfferContext.Provider>
  );
};

export const useExpandingOffer = () => {
  const context = useContext(ExpandingOfferContext);
  if (!context) {
    throw new Error(
      "ExpandingOfferContext not found. Must be used within ExpandingOfferProvider"
    );
  }
  return useStore(context);
};
